import * as actions from './action';
import reducers from './reducer';

export const Profile = { actions, reducers };
export { ProfileState } from './reducer';
